<script setup lang="ts">
import { computed } from 'vue'
import type { ExpRateChartSnapshot } from '@/domain/types'
import type { AppLocale } from '@/i18n/locales'
import type { RateUnit } from '@/core/display-settings'
import { expChartCopy } from '@/i18n/exp-chart'
import { presentExpChartReadout } from '@/ui/exp-chart-readout'
const props = defineProps<{ model?: ExpRateChartSnapshot; locale: AppLocale; rateUnit?: RateUnit; average?: number | null }>()
const copy = computed(() => expChartCopy[props.locale])
const readout = computed(() => presentExpChartReadout(props.model, props.locale, props.rateUnit, true))
// The daily skin compares the raw live value against its displayed session mean.
// Valid readouts retain their 1% tone independently of session or arrow visibility.
const tone = computed(() => {
  const average = props.average
  const value = props.model?.recent.value
  if (!readout.value.ready || average == null || !Number.isFinite(average)
    || value == null || !Number.isFinite(value)) return 'neutral'
  const difference = value - average
  const tolerance = Math.abs(average) * .01 + Number.EPSILON * Math.max(1, Math.abs(value), Math.abs(average)) * 4
  return Math.abs(difference) <= tolerance ? 'neutral' : difference < 0 ? 'below' : 'above'
})
</script>
<template>
  <div class="exp-live" data-exp-live :data-tone="tone" :data-live-status="model?.recent.status ?? 'unavailable'" :title="readout.description" :aria-label="readout.description" tabindex="0">
    <span class="daily-label"><span>{{ copy.realtime }}</span></span>
    <span class="daily-value"><b data-panel-measure>{{ readout.recent }}</b><small data-panel-measure>{{ readout.unit }}</small></span>
  </div>
</template>
